import styled from 'styled-components';
import { ArrowDown } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';

const StyledContainer = styled(Box).attrs({
  justify: 'center',
  align: 'center',
  bg: 'primaryBaseC2',
  color: 'background',
  borderRadius: '5px',
  cursor: 'pointer',
})`
  &:hover {
    background: ${({ theme }) => theme.colors.primaryBase};
  }
`;

const NewMessagesIndicator = ({ onClick = () => {} }) => {
  return (
    <StyledContainer onClick={onClick}>
      <Box horizontal align="center" px="16px" py="4px">
        <ArrowDown height={10} width={10} />
        <Text ml="3px" size="small">
          New Messages
        </Text>
      </Box>
    </StyledContainer>
  );
};

export default NewMessagesIndicator;
